import {useEffect} from 'react';
import {FieldValues, Path} from 'react-hook-form';
import {createErrorObj} from '@/helper';
import {IDefaultErrorObject} from '@/interfaces';
import {IUseHandleBackendErrors} from '@/api/interfaces';

const useHandleBackendErrors = <TFormValues extends FieldValues>({
    error = null,
    setError = () => {}
}: IUseHandleBackendErrors<TFormValues>) => {
    useEffect(() => {
        const errors = createErrorObj(error as IDefaultErrorObject)?.validation;

        if (errors) {
            for (const key in errors) {
                setError(key as Path<TFormValues>, {
                    message: (errors as Record<string, string>)?.[key] || 'Value is invalid'
                });
            }
        }
    }, [error, setError]);
};

export default useHandleBackendErrors;
